// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import store from "./store";
import axios from "axios";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/icon.css";
import "@/assets/css/main.css";
import "@/assets/css/reset.css";
import "@/assets/iconfont/iconfont.css";

import "@/assets/css/quill/quill.core.css";
import "@/assets/css/quill/quill.snow.css";
import "@/assets/css/quill/quill.bubble.css";

import "remixicon/fonts/remixicon.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import echarts from "echarts";
import { isVendor, isSubTenant } from "@/lib/tenant";
import { checkExpiredPlan, finishMessageBox } from "@/lib/element/messageBox";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.prototype.$echarts = echarts;
Vue.prototype.$isVendor = isVendor;
Vue.prototype.$isSubTenant = isSubTenant;

// 动态设置title和验证路由守卫是否需要登录
router.beforeEach((to, from, next) => {
  // 添加百度统计
  if (to.path) {
    _hmt.push(["_trackPageview", "/#" + to.fullPath]);
  }
  // next();

  // 验证路由守卫是否需要登录
  if (to.meta.requireAuth) {
    let token = localStorage.getItem("token");
    if (token) {
      // 生产环境屏蔽菜单管理
      if (
        to.name == "SettingMenuList" &&
        process.env.NODE_ENV != "development"
      ) {
        return next("/undefined");
      }

      const jurisdiction = localStorage.getItem("jurisdiction");
      const authorityPage = to.meta.authority;
      if (authorityPage) {
        if (jurisdiction) {
          const jurisdictionParse = JSON.parse(jurisdiction);
          // 权限校验
          const permissions = jurisdictionParse.permissions || [];
          if (permissions.includes(authorityPage)) {
            next();
            // 检查店铺是否过期
            checkExpiredPlan();
          } else {
            // return next("/authority");
            return next("/undefined");
          }
        } else {
          if (to.name == "ShopList") {
            next();
          } else {
            return next("/shop");
          }
        }
      } else {
        if (jurisdiction) {
          next();
        } else {
          if (
            to.name == "ShopList" ||
            to.name == "CreateShop" ||
            to.name == "Account"
          ) {
            next();
          } else {
            return next("/shop");
          }
        }
      }
    } else {
      return next("/login");
    }
  }

  if (navigator.userAgent.indexOf("MSIE") > -1) {
    Vue.prototype.$alert(
      "不兼容IE10及以下浏览器，请使用更高版本的浏览器查看",
      "浏览器不兼容通知",
      {
        confirmButtonText: "确定"
      }
    );
  }
  next();
});

// /* 请求拦截器 */
axios.interceptors.request.use(
  function(config) {
    // 每次请求时会从localStorage中获取token
    let token = localStorage.getItem("token");
    if (token) {
      token = "Bearer" + " " + token.replace(/'|"/g, ""); // 把token加入到默认请求参数中
      config.headers.common["Authorization"] = token;
    }

    //对url中的功能性字符进行编码
    let url = config.url;
    // get参数编码
    if (config.method === "get" && config.params) {
      url += "?";
      let keys = Object.keys(config.params);
      for (let key of keys) {
        url += `${encodeURIComponent(key)}=${encodeURIComponent(
          config.params[key]
        )}&`;
      }
      url = url.substring(0, url.length - 1);
      config.params = {};
    }
    config.url = url;

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

//是否"重新登录"存在，避免重复 alert
let isLoginAlertExists = false;

/* 响应拦截器 */
axios.interceptors.response.use(
  function(response) {
    if (response.data) {
      const resData = response.data;
      if (resData.code == 203021) {
        // 额度(例如直播可创建个数)用完提示
        finishMessageBox(
          resData.msg,
          resData.errorDescription,
          "调整",
          "升级套餐",
          "/purchase/versions/buy"
        );
        return Promise.reject(response);
      } else if (resData.code == 203022) {
        // 流量、存储空间使用完毕
        finishMessageBox(
          resData.msg,
          resData.errorDescription,
          "调整",
          "购买流量/存储",
          "/purchase/resource/flow"
        );
        return Promise.reject(response);
      }
    }
    return response;
  },
  function(error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (
            error.response.config.url.indexOf("/wx/get_openid_by_wx") != -1 ||
            error.response.config.url.indexOf("/order/setup_pay") != -1
          ) {
            // 微信h5
            alert("支付失效，请重新扫码后进入");
          } else {
            // 屏蔽掉刷新token和登录的接口
            if (!isLoginAlertExists) {
              isLoginAlertExists = true;
              ElementUI.Message({
                message: "登录失效，请重新登录",
                type: "error",
                onClose: () => {
                  isLoginAlertExists = false;
                }
              });
              // localStorage.clear()
              localStorage.removeItem("identity");
              localStorage.removeItem("username");
              localStorage.removeItem("tenantInfo");
              localStorage.removeItem("shopId");
              localStorage.removeItem("token");
              localStorage.removeItem("jurisdiction");
              localStorage.removeItem("crumbsNav");
              localStorage.removeItem("combo");
              // 返回 401 清除token信息并跳转到登录页面
              setTimeout(() => {
                router.replace({
                  path: "/login"
                });
              }, 1000);
            }
          }
          break;
        case 403:
          ElementUI.Message({
            message: "权限不足",
            type: "error"
          });
          // 返回403, 跳转到403页面
          setTimeout(() => {
            router.replace({
              path: "/authority"
            });
          }, 1000);
          break;
        default:
          ElementUI.Message({
            message: "请求失败",
            type: "error"
          });
      }
    }
    return Promise.reject(error);
  }
);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js